import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { FlexCenter } from '../../global/commonStyle';

interface DropBoxProps {
  applyDropBoxTopSpacing?: number;
  applyWidth?: string;
  editorHeight?: number;
}

const DropFileDiv = styled.div<DropBoxProps>`
  position: absolute;
  margin-top: -10px;
  width: ${({ applyWidth }) => applyWidth || '100%'};
  min-height: 96px;
  background: var(--background-secondary);
  z-index: var(--z-index-11);
  ${FlexCenter}
  gap: var(--space-4);
  flex-direction: column;
  pointer-events: none;
  border: 1px dashed var(--border-secondary);
  border-radius: var(--border-radius-8);
  top: 8px;
  ${(props) =>
    props.editorHeight &&
    css`
      height: ${props.editorHeight}px;
    `}
  span {
    ${Typography.body_md_medium}
    color: var(--text-primary);
  }

  ${({ applyDropBoxTopSpacing }) =>
    applyDropBoxTopSpacing &&
    css`
      top: ${applyDropBoxTopSpacing}px;
    `}
`;

export { DropFileDiv };
